import React from "react"
import md5 from "md5"
import ReactDOM from "react-dom"
import { Panel, Button, Glyphicon, SplitButton, MenuItem } from "react-bootstrap"
import _ from "underscore-node"
import Spinner from "react-spinkit"
import PolygonCropEditor from "./PolygonCropEditor"
import { Log } from "../lib/logger"

class ImageCropSelector extends React.Component {

    constructor(props){
        super(props)

        this.polygonCropEditorRef = React.createRef()

        this.state = {
            panelWidth: null,
            selectedImageStage: null,
            selectedImagepolyXNew: null,
            selectedImagepolyYNew: null,
            polygonNumberOfSides: 6
        }
    }

    componentDidMount = () => {
        if(!this.state.panelWidth && !this.selectedImageEditPanelHeading.current) {
            const eph = this.selectedImageEditPanelHeading
            const ephEl = ReactDOM.findDOMNode(eph)
            const ephElStype = window.getComputedStyle(ephEl)
            const horizontalPadding = parseInt(ephElStype.paddingRight, 10) + parseInt(ephElStype.paddingLeft, 10)
            const panelWidth = ephEl.offsetWidth - horizontalPadding
            this.setState({ panelWidth })
        }
    }

    componentDidUpdate = () => {
        if(this.props.scrollToImageCropSelector) {
            window.scrollTo({top: document.getElementById("ImageCropSelectorPanelBodyId").getBoundingClientRect().top, behavior: "smooth"})
            this.props.onScrolledToImageCropSelector()
        }
    }


    handleOnCroppedDataUrl = (url, newPolygonX, newPolygonY, newPolygonRadius, newPolygonRotation, lastCroppedSourceFileImageMd5) => {
        const newImage = { filePreviewUrl: url, imageMd5: md5(url)}
        this.props.onNewCroppedImage(newImage, newPolygonX, newPolygonY, newPolygonRadius, newPolygonRotation, lastCroppedSourceFileImageMd5)
    }

    handleGenerateCropClick = () => {
        // Get crop parameters and save to state
        const currentCropParameters = this.polygonCropEditorRef.current.getCurrentCropParameters()
        // Set generateCrop to true, so rerender of PolygonCropEditor can do the crop
        Log().time(`Creating ${this.state.polygonNumberOfSides}-agon crop`)
        this.props.onGenerateCrop({ ...currentCropParameters, generateCrop: true })
    }

    onSelectNoOfSides = (noOfSides) => {
        this.setState({ polygonNumberOfSides: Number.parseInt(noOfSides, 10)})
    }

    selectedImageEditPanelHeading = null

    render() {
        const selectedSourceImage = _.chain(this.props.sourceFiles)
            .findWhere({ imageMd5: this.props.selectedSourceFileImageMd5ForEdit })
            .value()

        return (
            <Panel>
                <Panel.Heading ref={pnlHdng => (this.selectedImageEditPanelHeading = pnlHdng)}>
                        Define your hexagonal crop &nbsp;&nbsp;
                    <SplitButton
                        bsStyle={"info"}
                        title={`${this.state.polygonNumberOfSides}-sided`}
                        id={`${this.state.polygonNumberOfSides}-sided`}
                        key={`noOfSidesDropdown`}
                        onSelect={this.onSelectNoOfSides}>
                        <MenuItem eventKey="3">3 - Triangle</MenuItem>
                        <MenuItem eventKey="4">4 - Square</MenuItem>
                        <MenuItem eventKey="5">5 - Pentagon</MenuItem>
                        <MenuItem eventKey="6" active>6 - Hexagon</MenuItem>
                        <MenuItem eventKey="7">7 - Heptagon</MenuItem>
                        <MenuItem eventKey="8">8 - Octagon</MenuItem>
                        <MenuItem eventKey="9">9 - Nonagon</MenuItem>
                        <MenuItem eventKey="10">10 - Decagon</MenuItem>
                        <MenuItem eventKey="11">11 - Hendecagon</MenuItem>
                        <MenuItem eventKey="12">12 - Dodecagon</MenuItem>
                    </SplitButton>
                    {!selectedSourceImage ? null :
                        <Button onClick={this.handleGenerateCropClick} bsStyle="success" style={{marginLeft: "10px"}}>
                        Create cropped image&nbsp;<Glyphicon glyph="picture"/>
                        </Button> 
                    }
                    {this.props.nudgeFromCropImage? <Glyphicon glyph="arrow-down" className="nudge-down cmwd-anim-nudge-down"/> : ""}
                    {this.props.generateCrop ? <Spinner name="wordpress" color="#398439" overrideSpinnerClassName={"float-left-in-heading"} /> : ""}
                </Panel.Heading>
                <Panel.Body id={"ImageCropSelectorPanelBodyId"}>
                    <PolygonCropEditor ref={this.polygonCropEditorRef}
                        polygonNumberOfSides={this.state.polygonNumberOfSides}
                        panelWidth={this.state.panelWidth}
                        cropPolygonX={this.props.cropPolygonX}
                        cropPolygonY={this.props.cropPolygonY}
                        cropPolygonRadius={this.props.cropPolygonRadius}
                        cropPolygonRotation={this.props.cropPolygonRotation || 0}
                        selectedSourceImage={selectedSourceImage}
                        lastCroppedSourceFileImageMd5={this.props.lastCroppedSourceFileImageMd5}
                        generateCrop={this.props.generateCrop}
                        onCroppedDataUrl={this.handleOnCroppedDataUrl} />
                </Panel.Body>
                <Panel.Footer>
                </Panel.Footer>
            </Panel>
        )
    }
}

export default ImageCropSelector


// WEBPACK FOOTER //
// ./src/components/ImageCropSelector.jsx